import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import styled from 'styled-components';
import { sizes } from 'theme';

interface StyledTextAreaProps extends TextAreaProps {
    $hasError?: boolean;
}

export const StyledTextArea = styled(Input.TextArea)<StyledTextAreaProps>`
    border-radius: ${sizes.radiusMd}px;
    width: 100%;

    border: 1px solid ${({ $hasError }) => ($hasError ? 'var(--error-normal)' : 'rgba(0, 0, 0, 0.15)')};

    &:focus {
        border: 1px solid ${({ $hasError }) => ($hasError ? 'var(--error-normal)' : 'var(--brand-6)')};
        box-shadow: 0px 0px 4px 0px
            ${({ $hasError }) => ($hasError ? 'rgba(255, 0, 0, 0.5)' : 'rgba(52, 48, 180, 0.5)')};
    }

    &:hover {
        border: 1px solid ${({ $hasError }) => ($hasError ? 'var(--error-normal)' : 'var(--brand-5)')};
    }
`;
